import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.59812 7.90703L1.99563 5.30453C1.70313 5.01203 1.23062 5.01203 0.938125 5.30453C0.645625 5.59703 0.645625 6.06953 0.938125 6.36203L4.07313 9.49703C4.36563 9.78953 4.83813 9.78953 5.13063 9.49703L13.0656 1.56203C13.3581 1.26953 13.3581 0.797031 13.0656 0.504531C12.7731 0.212031 12.3006 0.212031 12.0081 0.504531L4.59812 7.90703Z",
		fill: "#1D1D1D"
	})
});
export default SvgCheck;
